(function($) {

var pageId = 'page-file',
    page = '#' + pageId;

var uploader;

$(function() {
    $('body').on('click', page + ' .detail-action-edit', function(e) {
        e.preventDefault();
        $('.file-subject .file-title').trigger('click');
    }).on('ajax:beforeSend', page + ' .detail-action-del', function(e) {
        simple.loading({
            type: 'global',
            msg: '正在删除文件...'
        });
    }).on('ajax:success', page + ' .detail-action-del', function(e) {
        simple.loading.destroy();
    }).on('mouseenter', page + ' .link-file-newver', function(e) {
        initUploader();
    }).on('click', page + ' .cancel-update-version', function() {
        var cancelBtn = $(this),
            uploadBtn = cancelBtn.prev();

        uploader.cancel(cancelBtn.data('fileid'));
        cancelBtn.hide();
        uploadBtn.show();
    }).on('click', page + ' .file-subject .file-title', function() {
        if ($(page).is('[data-deleted], [data-archived]')) {
            return;
        }

        $(page + ' .file-title-change-form').show();
        $(page + ' h3.file-title-wrap').hide();
        $(page + ' .file-title-change-form input').focus().select();
    }).on('ajax:success', '.file-title-change-form form', function(e, result) {
        $(page + ' h3.file-title-wrap .file-title').html(result.title);
        $(page + ' .file-title-change-form').hide();
        $(page + ' h3.file-title-wrap').show();
    }).on('click', page + ' .file-title-change-form .btn-x', function() {
        $(page + ' .file-title-change-form').hide();
        $(page + ' h3.file-title-wrap').show();
    });

    tower.stack.on('pageunload', function(e) {
        uploader = null;
        return e.result;
    });
});

$(document).on('pjaxload#' + pageId, function(e, $page, page) {
    tower.adjustAuthor();
    tower.adjustAttachment();
    tower.adjustProjInfo();
    tower.adjustCommentsLike();
    tower.foldComments();
});


function initUploader() {
    if (uploader) return

    var uploadBtn = $('.link-file-newver');
    var cancelBtn = $('.cancel-update-version');
    var uploadUrl = uploadBtn.data('url');

    uploader = simple.uploader({
        url: uploadUrl,
        params: {
            conn_guid: $( "#conn-guid" ).val(),
            authenticity_token: $('meta[name=csrf-token]').attr('content')
        }
    });

    tower.connectUploader(uploadBtn, uploader, {
        title: '上传文件'
    });

    uploader.on('beforeupload', function(e, file) {
        if (!tower.checkUploadFileSize(file)) {
            return false;
        }

        uploadBtn.hide()
            .next('.cancel-update-version')
            .data('fileid', file.id).show();
    });

    uploader.on('uploadprogress', function(e, file, loaded, total) {
        var percent = loaded / total;
            percent = (percent * 100).toFixed(0) + "%";

        cancelBtn.text("正在上传: " + percent + " \u2716");
        cancelBtn.on('click', function(){
            uploader.cancel(cancelBtn.data('fileid'));
            uploadBtn.show().next('.cancel-update-version').hide();
        })
    });

    uploader.on('uploadsuccess', function(e, file, result) {
        cancelBtn.addClass('success').text("\u2714 上传成功");
        tower.stack.load(result.target_url, {
            replace: true
        });
    });
}

})(jQuery);

